const CityMap = new Map();
CityMap.set(11, "\u5317\u4eac");
CityMap.set(12, "\u5929\u6d25");
CityMap.set(13, "\u6cb3\u5317");
CityMap.set(14, "\u5c71\u897f");
CityMap.set(15, "\u5185\u8499\u53e4");
CityMap.set(21, "\u8fbd\u5b81");
CityMap.set(22, "\u5409\u6797");
CityMap.set(23, "\u9ed1\u9f99\u6c5f");
CityMap.set(31, "\u4e0a\u6d77");
CityMap.set(32, "\u6c5f\u82cf");
CityMap.set(33, "\u6d59\u6c5f");
CityMap.set(34, "\u5b89\u5fbd");
CityMap.set(35, "\u798f\u5efa");
CityMap.set(36, "\u6c5f\u897f");
CityMap.set(37, "\u5c71\u4e1c");
CityMap.set(41, "\u6cb3\u5357");
CityMap.set(42, "\u6e56\u5317");
CityMap.set(43, "\u6e56\u5357");
CityMap.set(44, "\u5e7f\u4e1c");
CityMap.set(45, "\u5e7f\u897f");
CityMap.set(46, "\u6d77\u5357");
CityMap.set(50, "\u91cd\u5e86");
CityMap.set(51, "\u56db\u5ddd");
CityMap.set(52, "\u8d35\u5dde");
CityMap.set(53, "\u4e91\u5357");
CityMap.set(54, "\u897f\u85cf");
CityMap.set(61, "\u9655\u897f");
CityMap.set(62, "\u7518\u8083");
CityMap.set(63, "\u9752\u6d77");
CityMap.set(64, "\u5b81\u590f");
CityMap.set(65, "\u65b0\u7586");
CityMap.set(71, "\u53f0\u6e7e");
CityMap.set(81, "\u9999\u6e2f");
CityMap.set(82, "\u6fb3\u95e8");
CityMap.set(91, "\u56fd\u5916");

export const common = {
  /*发票抬头正则*/
  invoiceRegex: /^((?!-{2,})[\w\-()（）\u4e00-\u9fa5]){5,50}$/,
  /*旅行社名称正则*/
  regNameRegex: /^((?!-{2,})[\w\-()（）\u4e00-\u9fa5]){5,50}$/,
  /*旅行社资质证书正则*/
  regCodeRegex: /^((?!-{2,})[0-9A-Z_\-()（）]){5,50}$/,
  guideRegex: /^((?!-{2,})[0-9A-Z-]){6,30}$/, // /^D\-[0-9]{4}\-[0-9]{6}$/,
  /*手机号码正则*/
  phoneRegex: /^(13[0-9]|15[012356789]|17[0-9]|18[0-9]|14[56789]|19[8-9]|166)[0-9]{8}$/, // /^1\d{10}$/;
  /*姓名正则*/
  nameRegex: /^[a-zA-Z0-9\u4e00-\u9fa5]{2,16}$/,
  /*6位验证码*/
  numRegex: /^\d{6}$/,
  /*简单密码过滤 不含长度控制*/
  simplePassword: /^(012345|543210|0123456|0123654|6543210|123456|1234567|12345678|123456789|1234567890|123321|456654|789987|0987654321|0987654|74108520|74185296|654321|7654321|87654321|987654|9876543|98765432|987654321|147852369|741258963|741852963|789456|789456123|789654123|321654|321654987|qwerty|QWERTY|qwertyu|QWERTYU|qwertyui|QWERTYUI|qwertyuio|QWERTYUIO|qwertyuiop|QWERTYUIOP|asdfgh|ASDFGH|asdfghj|ASDFGHJ|asdfghjk|ASDFGHJK|asdfghjkl|ASDFGHJKL|zxcvbn|ZXCVBN|zxcvbnm|ZXCVBNM|zxcvbnm,|ZXCVBNM,|((12){2,}|(23){2,}|(34){2,}|(45){2,}|(56){2,}|(21){2,}|(32){2,}|(43){2,}|(54){2,}|(01){2,}|(10){2,}|(02){2,}|(20){2,}|(03){2,}|(04){2,}|(30){2,}|(40){2,}|(012){2,}|(210){2,}|(123){2,}|(321){2,}|(234){2,}|(432){2,}|(456){2,}|(654){2,}|(987){2,}|(789){2,})|(a{2,}|b{2,}|c{2,}|d{2,}|e{2,}|f{2,}|g{2,}|h{2,}|i{2,}|g{2,}|k{2,}|l{2,}|m{2,}|n{2,}|o{2,}|p{2,}|q{2,}|r{2,}|s{2,}|t{2,}|u{2,}|v{2,}|w{2,}|x{2,}|y{2,}|z{2,}|A{2,}|B{2,}|C{2,}|D{2,}|E{2,}|F{2,}|G{2,}|H{2,}|I{2,}|J{2,}|K{2,}|L{2,}|M{2,}|N{2,}|O{2,}|P{2,}|Q{2,}|R{2,}|S{2,}|T{2,}|U{2,}|V{2,}|W{2,}|X{2,}|Y{2,}|Z{2,}|0{2,}|1{2,}|2{2,}|3{2,}|4{2,}|5{2,}|6{2,}|7{2,}|8{2,}|9{2,})+[0-9a-zA-Z]{0,2})$/,
  /*企业税号正则*/
  taxNoRegex: /^((?![IOZSVa-z])[A-Z\d]){10,30}$/,
  /*企业邮箱*/
  invoiceEmailRegex: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
  /*组织机构代码 */
  organizationCode: /^[^_IOZSVa-z\\W]{2}\\d{6}[^_IOZSVa-z\\W]{10}$/,
  /*用户名 */
  username: /^[a-z0-9A-Z]{6,25}$/,
  /* 详细地址*/
  addressRegex: /^[\u4e00-\u9fa5]{2,200}$/,
  /*简单密码过滤验证*/
  checkSimplePwd(t) {
    return this.simplePassword.test(t);
  },
  checkInvoiceTitle(t) {
    return this.invoiceRegex.test(t);
  },
  /*旅行社名称*/
  checkregName(regName) {
    return this.regNameRegex.test(regName);
  },
  /*旅行社资质证书验证*/
  checkregCode(regCode) {
    return this.regCodeRegex.test(regCode);
  },
  /*导游证件验证*/
  checkGuide(no) {
    return this.guideRegex.test(no);
  },
  /*手机号码合法验证*/
  checkPhone(phoneNo) {
    return this.phoneRegex.test(phoneNo);
  },
  /*验证码是否合法*/
  checkCode(code) {
    return this.numRegex.test(code);
  },
  checkPassport(input, passport) {
    const regex = /^((?!-{2,})[0-9a-zA-Z-]){5,30}$/; // ^[0-9a-zA-Z]{5,30}$/;
    return regex.test(passport);
  },
  isNama(name) {
    // const reg = common.nameRegex;
    return this.nameRegex.test(name);
  },

  // 身份证校验*************************************************************************************************
  isIDCard(str) {
    // const City = {
    //   11: "\u5317\u4eac",
    //   12: "\u5929\u6d25",
    //   13: "\u6cb3\u5317",
    //   14: "\u5c71\u897f",
    //   15: "\u5185\u8499\u53e4",
    //   21: "\u8fbd\u5b81",
    //   22: "\u5409\u6797",
    //   23: "\u9ed1\u9f99\u6c5f ",
    //   31: "\u4e0a\u6d77",
    //   32: "\u6c5f\u82cf",
    //   33: "\u6d59\u6c5f",
    //   34: "\u5b89\u5fbd",
    //   35: "\u798f\u5efa",
    //   36: "\u6c5f\u897f",
    //   37: "\u5c71\u4e1c",
    //   41: "\u6cb3\u5357",
    //   42: "\u6e56\u5317 ",
    //   43: "\u6e56\u5357",
    //   44: "\u5e7f\u4e1c",
    //   45: "\u5e7f\u897f",
    //   46: "\u6d77\u5357",
    //   50: "\u91cd\u5e86",
    //   51: "\u56db\u5ddd",
    //   52: "\u8d35\u5dde",
    //   53: "\u4e91\u5357",
    //   54: "\u897f\u85cf ",
    //   61: "\u9655\u897f",
    //   62: "\u7518\u8083",
    //   63: "\u9752\u6d77",
    //   64: "\u5b81\u590f",
    //   65: "\u65b0\u7586",
    //   71: "\u53f0\u6e7e",
    //   81: "\u9999\u6e2f",
    //   82: "\u6fb3\u95e8",
    //   91: "\u56fd\u5916 ",
    // };
    let iSum = 0;
    // const info = "";
    str = str.replace("\uff38", "X");
    str = str.replace("x", "X");
    if (!/^\d{17}(\d|x)$/i.test(str)) {
      return false;
    }
    str = str.replace(/x$/i, "a");
    // if (City[parseInt(str.substr(0, 2), 10)] == null) {
    //   return false;
    // }
    if (CityMap.get(parseInt(str.substr(0, 2), 10)) === null) {
      return false;
    }
    const sBirthday = str.substr(6, 4) + "-" + Number(str.substr(10, 2)) + "-" + Number(str.substr(12, 2));
    const d = new Date(sBirthday.replace(/-/g, "/"));
    if (sBirthday !== d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()) {
      return false;
    }
    for (let i = 17; i >= 0; i--) {
      iSum += (Math.pow(2, i) % 11) * parseInt(str.charAt(17 - i), 11);
    }
    if (iSum % 11 !== 1) {
      return false;
    }
    return true;
  },
  isOld(str) {
    const oldYear = parseInt(str.substring(6, 10), 10);
    const date = new Date();
    const nowYear = date.getFullYear();
    if (nowYear - oldYear >= 60) {
      return true;
    }
    return false;
  },
  isPassword(pwd) {
    let isOk = false;
    const regex = /^(?=.*\d)(?=.*[a-zA-Z]).{8,16}$/;
    isOk = regex.test(pwd);
    if (isOk && common.checkSimplePwd(pwd)) {
      return "simple";
    }
    return isOk;
  },
  illegalChar(str, param) {
    let reg = "[`~\\\\!@#$%^&*()_+<>?:\"{},/;'[\\]]";
    if (param) {
      for (const item of param) {
        reg = reg.replace(item, "");
      }
    }
    const pattern = new RegExp(reg, "im");
    if (pattern.test(str)) {
      return false;
    }
    return true;
  },
  isTaxNo(str) {
    return this.taxNoRegex.test(str);
  },
  isInvoiceEmail(str) {
    return this.invoiceEmailRegex.test(str);
  },
  isOrganizationCode(str) {
    return this.organizationCode.test(str);
  },
  isUserName(str) {
    return this.username.test(str);
  },
  isAddressRegex(str) {
    return this.addressRegex.test(str);
  },
};
